import { render } from "./CustomerTypeSelectionView.vue?vue&type=template&id=74d27616"
import script from "./CustomerTypeSelectionView.vue?vue&type=script&lang=js"
export * from "./CustomerTypeSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__